<template>
  <div>
    <NavBar></NavBar>
    <router-view></router-view>
    <FooterBar></FooterBar>
    <a href="#" class="scroll-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>
  </div>
</template>
<script>

import NavBar from '@/components/Common/NaviBar.vue'
import FooterBar from '@/components/Common/FooterBar.vue'

export default {
  name: 'App',
  components: { NavBar, FooterBar },
  data () {
    return {
      NavBar,
      FooterBar
    }
  },
  setup () {},
  created () {},
  mounted () {},
  unmounted () {},
  methods: {
  }
}
</script>
